<template>
  <div class="row">

    <div class="span-1-lg offset-2-lg span-1-md hide-sm">
      <div class="p subheader survey-number transition-1">{{ind}}.</div>
    </div>

    <div class="span-10-lg span-14-md span-14-sm offset-1-sm span-14-xs offset-1-xs ">
      <p class="large border-error-container"><slot></slot></p>
    </div>

  </div>
</template>

<script>
  export default {
    props: ['ind', 'caption']
  }
</script>

<style scoped lang='scss'>

  // @import '../../styles/variables';

  .survey-number {
    position: relative;
    text-align: right;
    top: 50%;
    transform: translateY(-50%);
    padding-right: 24px;
  }

</style>



// WEBPACK FOOTER //
// surveyCaption.vue?253a984a